module.exports = __webpack_public_path__ + "img/aisaku_camera_icon.4d2126e1.svg";